/* Aquatic Ponic — site behaviour. No dependencies. */
(function () {
  var root = document.querySelector('.ap'); if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); }, $$ = function (s, c) { return [].slice.call((c || root).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // reveal on scroll
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    $$('.rv').forEach(function (el) { io.observe(el); });
  } else { $$('.rv').forEach(function (el) { el.classList.add('is-in'); }); }

  // image fallback: a named placeholder instead of a broken image
  $$('img[data-slot]').forEach(function (img) {
    var miss = function () { var d = document.createElement('div'); d.className = 'slot-miss'; d.innerHTML = img.getAttribute('data-slot') + '<small>render in progress</small>'; if (img.parentNode) img.parentNode.replaceChild(d, img); };
    if (img.complete && !img.naturalWidth) miss(); else img.addEventListener('error', miss);
  });

  // mobile menu
  var mnav = $('.mnav'), mb = $('.menu-btn');
  if (mnav && mb) {
    var closeM = function () { mnav.classList.remove('open'); mb.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; };
    mb.addEventListener('click', function () { mnav.classList.add('open'); mb.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden'; $('.x', mnav).focus(); });
    $('.x', mnav).addEventListener('click', function () { closeM(); mb.focus(); });
    $$('a', mnav).forEach(function (a) { a.addEventListener('click', closeM); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mnav.classList.contains('open')) { closeM(); mb.focus(); } });
  }

  // gallery
  $$('.gal').forEach(function (g) {
    var main = $('.gal-main img', g);
    $$('.gal-th button', g).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = b.getAttribute('data-src'); main.alt = b.getAttribute('data-alt') || '';
        main.classList.toggle('cover', b.hasAttribute('data-cover'));
        $$('.gal-th button', g).forEach(function (o) { o.setAttribute('aria-current', o === b ? 'true' : 'false'); });
      });
    });
  });

  // quantity + buy link (Shopify cart permalink: /cart/<variant>:<qty> goes straight to checkout)
  $$('.buy-row').forEach(function (row) {
    var out = $('output', row), buy = $('[data-variant]', row), n = 1;
    var sync = function () { if (out) out.textContent = n; if (buy && buy.getAttribute('data-variant')) buy.href = '/cart/' + buy.getAttribute('data-variant') + ':' + n; };
    $$('.qty button', row).forEach(function (b) { b.addEventListener('click', function () { n = Math.max(1, Math.min(9, n + (b.getAttribute('data-d') === '+' ? 1 : -1))); sync(); }); });
    sync();
  });

  // reserve / newsletter forms. On Shopify these are real customer forms; on the local preview they just confirm.
  $$('form.reserve').forEach(function (f) {
    if (f.getAttribute('action')) { if (/[?&]customer_posted=true/.test(location.search) && location.hash === '#' + f.id) f.classList.add('done'); return; }
    f.addEventListener('submit', function (e) { e.preventDefault(); f.classList.add('done'); var ok = $('.ok', f); if (ok) { ok.setAttribute('tabindex', '-1'); ok.focus(); } });
  });

  // shop filter chips
  var chips = $$('.chip[data-f]');
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      var f = c.getAttribute('data-f');
      chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
      $$('[data-kind]').forEach(function (p) { p.hidden = !(f === 'all' || p.getAttribute('data-kind') === f); });
    });
  });

  // hero life: the photo's own bubbles rise and its own fish swim. The photo is swapped for a clean plate (the same
  // render with the bubbles and fish left out) and the cut-outs are drawn, moving, on a canvas over it.
  // The layers and the map below come from products/hero-life (pack.py rewrites the LIFE line).
  var LIFE = /*LIFE*/{"w":1600,"h":1000,"vent":[1322,752],"zone":[-80,70,1680,440],"fish":6,"b":[[0,0,54,48],[56,0,44,46],[102,0,35,29],[139,0,24,24],[165,0,25,24],[192,0,23,24],[217,0,24,24],[243,0,20,21],[265,0,17,21],[284,0,15,18],[301,0,18,18],[321,0,18,18],[341,0,13,15]],"f":[[0,50,166,97],[168,50,166,97],[336,50,166,97],[0,149,148,79],[150,149,148,79],[300,149,148,79]],"m":[0,230,235,250,860,0,470,500]}/*END*/;
  var bg = $('.hero-bg[data-life]');
  if (bg && LIFE && !reduce && bg.parentNode) {
    var hero = bg.parentNode, plate = new Image(), sheet = new Image(), left = 2;
    var rnd = function (a, b) { return a + Math.random() * (b - a); };
    var startLife = function () {
      var cv = document.createElement('canvas'), cx = cv.getContext('2d');
      if (!cx || !bg.parentNode) return;
      cv.className = 'hero-life'; cv.setAttribute('aria-hidden', 'true');
      var IW = LIFE.w, IH = LIFE.h, dpr = 1, sc = 1, ox = 0, oy = 0;
      var fit = function () {
        var r = bg.getBoundingClientRect(), pos = getComputedStyle(bg).objectPosition.split(' ');
        var px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1]) / 100;
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        cv.width = Math.max(1, Math.round(r.width * dpr)); cv.height = Math.max(1, Math.round(r.height * dpr));
        sc = Math.max(r.width / IW, r.height / IH);   // same maths as object-fit: cover
        ox = (r.width - IW * sc) * (isNaN(px) ? .5 : px); oy = (r.height - IH * sc) * (isNaN(py) ? .5 : py);
      };

      // air leaving the siphon outlet: a steady trickle, and a burp every few seconds
      var V = LIFE.vent, bubs = [], due = 0, burp = rnd(2, 5), burpN = 0;
      var bubble = function (y) {
        var k = LIFE.b[Math.random() * LIFE.b.length | 0], z = rnd(.5, 1);
        return { k: k, y: y == null ? V[1] : y, z: z, x0: V[0] + rnd(-7, 7), v: (70 + k[3] * z * 3.4) * rnd(.85, 1.15),
          lean: rnd(-.05, .1), amp: rnd(2, 7), w: rnd(2.4, 4.4), ph: rnd(0, 6.3) };
      };
      for (var i = 0; i < 13; i++) bubs.push(bubble(rnd(-20, V[1])));

      // fish: wander the planted background, turn around, now and then dart
      var Z = LIFE.zone, fish = [], half = LIFE.f.length / 2;
      var aim = function (f) {
        f.tx = rnd(Z[0], Z[2]); f.ty = rnd(Z[1], Z[3]); f.t = rnd(4, 11);
        if (Math.random() < .2) f.dart = 1;
      };
      for (i = 0; i < LIFE.fish; i++) {
        var d = i / (LIFE.fish - 1);   // 0 = far back, 1 = nearest
        var f = { d: d, x: rnd(Z[0], Z[2]), y: rnd(Z[1], Z[3]), vx: 0, vy: 0, dart: 0, ph: rnd(0, 6.3),
          k: LIFE.f[(d < .5 ? 0 : half) + i % half], len: 50 + 34 * d, sp: 16 + 16 * d };
        aim(f); f.face = f.tx > f.x ? 1 : -1; fish.push(f);
      }

      var on = true, last = 0;
      var frame = function (now) {
        requestAnimationFrame(frame);
        var dt = Math.min(.05, (now - last) / 1000), t = now / 1000; last = now;
        if (!on || hero.classList.contains('tank-on')) return;
        cx.setTransform(1, 0, 0, 1, 0, 0); cx.clearRect(0, 0, cv.width, cv.height);
        cx.setTransform(dpr * sc, 0, 0, dpr * sc, dpr * ox, dpr * oy);

        fish.forEach(function (f) {
          var dx = f.tx - f.x, dy = f.ty - f.y, dist = Math.sqrt(dx * dx + dy * dy) || 1;
          f.t -= dt; if (dist < 50 || f.t < 0) aim(f);
          f.dart = Math.max(0, f.dart - dt * .7);
          var v = f.sp * (1 + 2.4 * f.dart), k = 1 - Math.exp(-dt * (.9 + 2 * f.dart));
          f.vx += (dx / dist * v - f.vx) * k; f.vy += (dy / dist * v * .5 - f.vy) * k;
          f.x += f.vx * dt; f.y += f.vy * dt + Math.sin(t * .7 + f.ph) * 2 * dt;
          if (Math.abs(f.vx) > 1.5) f.face += ((f.vx > 0 ? 1 : -1) - f.face) * (1 - Math.exp(-dt * 3.2));
          var q = f.len / f.k[2], wag = 1 + .035 * Math.sin(t * (5 + 6 * f.dart) + f.ph);
          cx.save(); cx.translate(f.x, f.y); cx.rotate(Math.atan2(f.vy, Math.abs(f.vx) + 12) * .7 * (f.face < 0 ? -1 : 1));
          cx.scale(f.face * q * wag, q); cx.globalAlpha = .62 + .33 * f.d;
          cx.drawImage(sheet, f.k[0], f.k[1], f.k[2], f.k[3], -f.k[2] / 2, -f.k[3] / 2, f.k[2], f.k[3]);
          cx.restore();
        });
        // the airline and the dome stand in front of the fish
        var M = LIFE.m; cx.globalCompositeOperation = 'destination-out';
        cx.drawImage(sheet, M[0], M[1], M[2], M[3], M[4], M[5], M[6], M[7]);
        cx.globalCompositeOperation = 'source-over';

        due -= dt; burp -= dt;
        if (burp < 0) { burp = rnd(4.5, 8); burpN = 5 + (Math.random() * 6 | 0); }
        if (due < 0) { bubs.push(bubble()); if (burpN > 0) { burpN--; due = rnd(.05, .16); } else due = rnd(.25, .7); }
        for (i = bubs.length; i--;) {
          var b = bubs[i], up = V[1] - b.y;
          b.y -= b.v * dt;
          if (b.y < -30) { bubs.splice(i, 1); continue; }
          var bw = b.k[2] * b.z, bh = b.k[3] * b.z * (1 + .05 * Math.sin(t * 9 + b.ph));
          var bx = b.x0 + b.lean * up + Math.sin(t * b.w + b.ph) * b.amp * Math.min(1, up / 120);
          cx.globalAlpha = Math.max(0, Math.min(1, up / 26));
          cx.drawImage(sheet, b.k[0], b.k[1], b.k[2], b.k[3], bx - bw / 2, b.y - bh / 2, bw, bh);
        }
        cx.globalAlpha = 1;
      };
      fit(); bg.src = plate.src; bg.after(cv);
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(hero); else window.addEventListener('resize', fit);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { on = es[0].isIntersecting; }).observe(hero);
      requestAnimationFrame(function (now) { last = now; frame(now); });
    };
    plate.onload = sheet.onload = function () { if (!--left) startLife(); };
    plate.src = bg.getAttribute('data-plate'); sheet.src = bg.getAttribute('data-life');
  }

  // the flood-and-drain cycle diagram
  $$('[data-cycle]').forEach(function (fig) {
    var water = $('.cyc-water', fig), vent = $('.cyc-vent', fig), inb = $('.cyc-in', fig), label = $('.cyc-label', fig);
    var steps = $$('.steps li', fig.closest('.cycle') || root);
    var HI = +fig.getAttribute('data-hi'), LO = +fig.getAttribute('data-lo'), BOT = +fig.getAttribute('data-bot'), DUR = 9000;
    var names = ['Air in', 'Roots breathe', 'Water returns'];
    var set = function (t) {
      var y, s;
      if (t < 0.62) { y = HI + (LO - HI) * (t / 0.62); s = t < 0.34 ? 0 : 1; }
      else if (t < 0.74) { var k = (t - 0.62) / 0.12; k = k * k * (3 - 2 * k); y = LO + (HI - LO) * k; s = 2; }
      else { y = HI; s = 2; }
      water.setAttribute('y', y); water.setAttribute('height', Math.max(0, BOT - y));
      if (vent) vent.style.opacity = (t >= 0.62 && t < 0.8) ? 1 : 0;
      if (inb) inb.style.opacity = t < 0.62 ? 1 : 0.25;
      if (label) label.textContent = names[s];
      steps.forEach(function (li, i) { li.classList.toggle('on', i === s); });
    };
    if (reduce) { set(0.3); steps.forEach(function (li) { li.classList.add('on'); }); return; }
    var on = false, t0 = performance.now();
    var tick = function (now) { if (!on) return; set(((now - t0) % DUR) / DUR); requestAnimationFrame(tick); };
    new IntersectionObserver(function (es) { on = es[0].isIntersecting; if (on) requestAnimationFrame(tick); }).observe(fig);
    set(0);
  });

  // sticky bar: show after the hero, hide near the buy box / footer
  var sbar = $('.sbar');
  if (sbar) {
    var hideEls = $$('[data-sbar-hide], .ftr');
    var upd = function () {
      var show = window.scrollY > 500;
      hideEls.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) show = false; });
      sbar.classList.toggle('show', show);
    };
    window.addEventListener('scroll', upd, { passive: true }); upd();
  }
})();

// hidden tank: the fish in the home hero swaps the photo for a 3D tank that follows the viewer's eyes.
// The heavy part (ap-tank.js, three.js, the eye tracker) is only fetched after the tap.
(function () {
  var egg = document.querySelector('.ap .tank-egg');
  if (!egg) return;
  var hero = egg.closest('.hero'), ask = hero.querySelector('.tank-ask'), stop = null, busy = false;
  function run(useCamera) {
    if (busy) return;
    busy = true; ask.hidden = true; hero.classList.add('tank-loading');
    // loaded with a script tag, not import(): Shopify's asset minifier rewrites import() into require()
    new Promise(function (ok, fail) {
      if (window.apTank) return ok();
      var s = document.createElement('script');
      s.src = egg.getAttribute('data-tank-src'); s.onload = ok; s.onerror = fail;
      document.head.appendChild(s);
    })
      .then(function () { return window.apTank.start(hero, { camera: useCamera }); })
      .then(function (s) { stop = s; hero.classList.add('tank-on'); egg.setAttribute('aria-label', 'Leave the tank'); })
      .catch(function (e) { console.error(e); })
      .then(function () { hero.classList.remove('tank-loading'); busy = false; });
  }
  egg.addEventListener('click', function () {
    if (busy) return;
    if (stop) { stop(); stop = null; hero.classList.remove('tank-on'); egg.setAttribute('aria-label', 'Look inside the tank'); return; }
    ask.hidden = !ask.hidden;
  });
  ask.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tank]');
    if (b) run(b.getAttribute('data-tank') === 'cam');
  });
})();

/* Klaviyo (added 2026-10-05): every reserve / newsletter form also subscribes the email to the list "AP - Newsletter"
   (XXdwNA) in the Davision Klaviyo account (UneZNa). A reserve form also sends the event "AP Reserved" with the product,
   which starts the reserve confirmation email. The Shopify customer form still submits as before. */
(function () {
  var NAMES = { 'the-bubble-grande': 'The Bubble Grande', 'the-sill': 'The Sill', 'the-counter': 'The Counter', 'the-stand': 'The Stand',
    'air-kit': 'Air Kit', 'grow-gravel': 'Grow Gravel', 'seed-set': 'Seed Set', 'the-bubble': 'The Bubble' };
  var send = function (path, body) {
    try {
      fetch('https://a.klaviyo.com/client/' + path + '/?company_id=UneZNa', { method: 'POST', keepalive: true,
        headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' }, body: JSON.stringify(body) });
    } catch (e) {}
  };
  document.querySelectorAll('form.reserve[action]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[type="email"]');
      if (!input || !input.value) return;
      var email = input.value.trim(), slug = form.getAttribute('data-tag') || 'newsletter';
      send('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'Aquatic Ponic site form', profile: { data: { type: 'profile', attributes: {
        email: email, properties: { ap_signup: 'yes' }, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: 'XXdwNA' } } } } });
      if (slug !== 'newsletter') {
        send('events', { data: { type: 'event', attributes: { properties: { brand: 'aquatic-ponic', slug: slug, product: NAMES[slug] || slug, url: location.origin + location.pathname },
          metric: { data: { type: 'metric', attributes: { name: 'AP Reserved' } } },
          profile: { data: { type: 'profile', attributes: { email: email, properties: { ap_signup: 'yes' } } } } } } });
      }
    });
  });
})();
